import Accordion from 'src/components/section/Accordion';
import { Grid, Typography } from '@material-ui/core';
import contact from 'src/constants/contact';
import LabeledValue from 'src/components/HelpInfo/LabeledValue';

const ContactAccordion = () => {
  const { email, phone, street, room, city, state, zip, hours, contactName, title } = contact;
  return (
    <Accordion subtitle={'Contact'} flexDirection={'column'}>
      <Grid spacing={2} container>
        <Grid item xs={12}>
          <LabeledValue label="Located at">
            <Typography variant="body2">
              {contactName}, {title}
              <br /> {street}
              <br /> {room}
              <br /> {city}, {state} {zip}
            </Typography>
          </LabeledValue>
        </Grid>
        <Grid item xs={12}>
          <Grid item>
            <LabeledValue label="Phone">
              <Typography variant="body2">
                <a href={`tel:${phone}`}>{phone}</a>
              </Typography>
            </LabeledValue>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <LabeledValue label="Email">
            <Typography variant="body2">
              <a href={`mailto:${email}`}>{email}</a>
            </Typography>
          </LabeledValue>
        </Grid>
        <Grid item xs={12}>
          <Grid item>
            <LabeledValue label="Hours">
              <Typography variant="body2">{hours}</Typography>
            </LabeledValue>
          </Grid>
        </Grid>
      </Grid>
    </Accordion>
  );
};

export default ContactAccordion;
